import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {Route, Switch, useHistory} from 'react-router-dom';
import {EditGame} from '../../components/CompanyComponents';
import {openDialog} from '../../slices/dialog';
import {selectSelectedGame, selectSelectedRmId, storeSelectedGame} from '../../slices/selected';
import {getGamesListener} from '../../api/company';
import AddIcon from "@material-ui/icons/Add";
import CardRmGameBrief from '../../components/Cards/Rm/GameBrief';
import {CompanyRmGame} from './RmGame';
import Button from '../../components/Common/Button';
import {isExpired} from '../../helpers/misc';
import {useTranslation} from 'react-i18next';
import {ROUTES} from '../../db/models/const';

export const CompanyRmGames = (props) => {
    const [filteredGames, setFilteredGames] = useState([]);
    const [games, setGames] = useState([]);
    const selectedGame = useSelector(selectSelectedGame);
    const selectedGameRef = useRef();
    const dispatch = useDispatch();
    const rmId = useSelector(selectSelectedRmId);
    const history = useHistory();
    const [view, setView] = useState("all");
    const {t} = useTranslation();

    useEffect(() => {
        selectedGameRef.current = selectedGame;
    }, [selectedGame])

    const showGames = () => {
        setFilteredGames(games);
        setView("all");
        history.push(ROUTES.COMPANY_RM_GAMES);
    }

    const showActiveGames = () => {
        setView("open");
        setFilteredGames(games.filter(g => !isExpired(g.deadline)));
        history.push(ROUTES.COMPANY_RM_GAMES);
    }

    const showClosedGames = () => {
        setView("closed");
        setFilteredGames(games.filter(g => isExpired(g.deadline)));
        history.push(ROUTES.COMPANY_RM_GAMES);
    }

    useEffect(() => {
        if (!rmId) {
            history.push(ROUTES.ME);
            return;
        }

        const unsub = getGamesListener(rmId, snapshot => {
            const games = [];
            snapshot.docs.forEach(doc => {
                if (doc.exists) games.push(doc.data());
            });
            setGames(games);

            if (view === "all") setFilteredGames(games);
            if (view === "open") setFilteredGames(games.filter(g => !isExpired(g.deadline)));
            if (view === "closed") setFilteredGames(games.filter(g => isExpired(g.deadline)));

            // if selected game was updated, update it to see changes in game details page
            if (selectedGameRef.current) {
                const found = games.find(g => g.id === selectedGameRef.current.id);

                if (found) dispatch(storeSelectedGame({game: found}));
            }
        });

        return unsub;

    }, [rmId]);

    const onEditClick = (game) => {
        dispatch(openDialog({
            Content: EditGame,
            title: game ? t("company_rm_editGame_title") : t("company_rm_addGame_title"),
            props: {game, rmId},
            closable: true
        }));
    };

    return (
        <div className="companyGames">
            <div className="bar">
                <div className="bar__left">
                    <button className={`bar__link ${view === "all" ? "bar__link--active" : ""}`}
                            onClick={() => showGames()}>{t("company_rm_games_all")}</button>
                    <div className="bar__divider"></div>
                    <button className={`bar__link ${view === "open" ? "bar__link--active" : ""}`}
                            onClick={() => showActiveGames()}>{t("company_rm_games_open")}</button>
                    <button className={`bar__link ${view === "closed" ? "bar__link--active" : ""}`}
                            onClick={() => showClosedGames()}>{t("company_rm_games_closed")}</button>
                </div>
                <Button onClick={() => onEditClick()}>
                    <AddIcon/>
                    {t("company_rm_games_addGameBtn")}
                </Button>
            </div>
            <Switch>
                <Route path={ROUTES.COMPANY_RM_GAMES} exact render={() =>
                    <div className="companyGames__games">
                        {filteredGames.map((game) => (
                            <CardRmGameBrief key={game.id} game={game} editable={true}/>
                        ))}
                    </div>
                }/>
                <Route path={ROUTES.COMPANY_RM_GAMES_GAME} exact component={CompanyRmGame}/>
            </Switch>
        </div>
    );
};